module.exports = __webpack_public_path__ + "img/download_pdficon.98f516e3.svg";